import { MutationTree } from 'vuex';
import * as TYPES from './types';
import { IState } from './state';
import { Message } from 'element-ui';

export const mutations: MutationTree<any> = {

    // 获取公告分页数据信息
    [TYPES.GET_NOTICELIST_NAME.REQUEST](state: IState) {
        state.noticeList.loading = true;
    },
    [TYPES.GET_NOTICELIST_NAME.SUCCESS](state: IState, payload) {
        const { Data } = payload.res;
        state.noticeList.loading = false;
        state.noticeList.infos = Data;
    },
    [TYPES.GET_NOTICELIST_NAME.FAILED](state: IState) {
        state.noticeList.loading = false;
    },

    // 获取公告分页数据信息 -- 分类
    [TYPES.GET_TYPE_NOTICELIST_NAME.REQUEST](state: IState) {
        state.typeNoticeList.loading = true;
    },
    [TYPES.GET_TYPE_NOTICELIST_NAME.SUCCESS](state: IState, payload) {
        const { Items } = payload.res.Data || { Items: [] };
        state.typeNoticeList.loading = false;
        state.typeNoticeList.infos = Items;
    },
    [TYPES.GET_TYPE_NOTICELIST_NAME.FAILED](state: IState) {
        state.typeNoticeList.loading = false;
    },

    // 查看公告详情
    [TYPES.GET_NOTICDETAIL_NAME.REQUEST](state: IState) {
        state.noticeDetail.loading = true;
    },
    [TYPES.GET_NOTICDETAIL_NAME.SUCCESS](state: IState, payload) {
        state.noticeDetail.loading = false;
        state.noticeDetail.info = payload.res.Data;
    },
    [TYPES.GET_NOTICDETAIL_NAME.FAILED](state: IState) {
        state.noticeDetail.loading = false;
    },

    // 公告点赞
    [TYPES.PRAISE_NOTICE_META.REQUEST](state: IState) {
        //
    },
    [TYPES.PRAISE_NOTICE_META.SUCCESS](state: IState, payload) {
        const { info } = state.noticeDetail;
        state.noticeDetail.info = {
            ...state.noticeDetail.info,
            IsPraised: 1,
            PraiseCount: info.PraiseCount + 1
        };
        Message({
            message: payload.res.Message,
            type: 'success'
        });
    },
    [TYPES.PRAISE_NOTICE_META.FAILED](state: IState) {
        //
    },

    // 公告取消点赞
    [TYPES.CANCEL_PRAISE_NOTICE_META.REQUEST](state: IState) {
        //
    },
    [TYPES.CANCEL_PRAISE_NOTICE_META.SUCCESS](state: IState, payload) {
        const { info } = state.noticeDetail;
        state.noticeDetail.info = {
            ...info,
            IsPraised: 0,
            PraiseCount: info.PraiseCount - 1
        };
        Message({
            message: payload.res.Message,
            type: 'success'
        });
    },
    [TYPES.CANCEL_PRAISE_NOTICE_META.FAILED](state: IState) {
        //
    },

     // 公告详情 -- 新增评论
     [TYPES.ADD_NOTICE_COMMENT_META.REQUEST](state: IState) {
        state.addNoticeCommentRes.loading = true;
        state.addNoticeCommentRes.success = false;
    },
    [TYPES.ADD_NOTICE_COMMENT_META.SUCCESS](state: IState, payload) {
        state.addNoticeCommentRes.loading = false;
        state.addNoticeCommentRes.success = true;
        Message({
            message: payload.res.Message,
            type: 'success'
        });
    },
    [TYPES.ADD_NOTICE_COMMENT_META.FAILED](state: IState) {
        state.addNoticeCommentRes.loading = false;
        state.addNoticeCommentRes.success = false;
    },

      // 公告详情 -- 删除评论
      [TYPES.DEL_NOTICE_COMMENT_META.REQUEST](state: IState) {
          state.delNoticeCommentRes.loading = true;
          state.delNoticeCommentRes.success = false;
    },
    [TYPES.DEL_NOTICE_COMMENT_META.SUCCESS](state: IState, payload) {
        state.delNoticeCommentRes.loading = false;
        state.delNoticeCommentRes.success = true;
        Message({
            message: payload.res.Message,
            type: 'success'
        });
    },
    [TYPES.DEL_NOTICE_COMMENT_META.FAILED](state: IState) {
        state.delNoticeCommentRes.loading = false;
        state.delNoticeCommentRes.success = false;
    },

     // 公告详情 -- 当前登录人是否有公告管理权限
     [TYPES.HAS_NOTICE_PERMISSION_META.REQUEST](state: IState) {
        //
    },
    [TYPES.HAS_NOTICE_PERMISSION_META.SUCCESS](state: IState, payload) {
        state.isNoticePermission = payload.res.Data;
    },
    [TYPES.HAS_NOTICE_PERMISSION_META.FAILED](state: IState) {
        //
    },

     // 公告详情 -- 当前登录人是否有公告管理权限
     [TYPES.UPDATE_NOTICE_VIEW_META.REQUEST](state: IState) {
        //
    },
    [TYPES.UPDATE_NOTICE_VIEW_META.SUCCESS](state: IState, payload) {
        //
    },
    [TYPES.UPDATE_NOTICE_VIEW_META.FAILED](state: IState) {
        //
    }
};
